import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-152b7a3a")

_pushScopeId("data-v-152b7a3a")
const _hoisted_1 = {
  key: 0,
  class: "overlay"
}
const _hoisted_2 = { class: "videoQuality" }
const _hoisted_3 = {
  key: 0,
  class: "video-wrapper",
  ref: "videoSlot"
}
const _hoisted_4 = { class: "speaker-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_userVideoMock = _resolveComponent("userVideoMock")
  const _component_SpeakerName = _resolveComponent("SpeakerName")
  const _component_Button = _resolveComponent("Button")
  const _component_usersOverflowMock = _resolveComponent("usersOverflowMock")
  const _component_MediaSlotReactions = _resolveComponent("MediaSlotReactions")

  return (_openBlock(), _createBlock("div", {
    class: ["videoSlot", _ctx.videoSlotClasses],
    ref: "containerElement",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickMediaSlot && _ctx.onClickMediaSlot(...args)))
  }, [
    (_ctx.isOverLay)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("p", null, _toDisplayString(_ctx.reqVideoQuality), 1),
            _createVNode("p", null, _toDisplayString(_ctx.gotVideoQuality), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isOverFlow)
      ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (_ctx.stream.video?.mediaElement && _ctx.stream.canPlay && _ctx.isEnabled)
            ? (_openBlock(), _createBlock("div", _hoisted_3, null, 512))
            : (_openBlock(), _createBlock(_component_userVideoMock, {
                key: 1,
                name: _ctx.stream.title.label
              }, null, 8, ["name"])),
          _createVNode("div", _hoisted_4, [
            (_ctx.isShowNameProps)
              ? (_openBlock(), _createBlock(_component_SpeakerName, {
                  key: 0,
                  class: "speaker",
                  endpointId: _ctx.stream.id,
                  name: _ctx.stream.title.label,
                  hasVideo: !!_ctx.stream.video?.mediaElement
                }, null, 8, ["endpointId", "name", "hasVideo"]))
              : _createCommentVNode("", true),
            (_ctx.muted)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 1,
                  mode: "alert",
                  size: "s",
                  icon: {spriteUrl: '/image/videoconf-icons.svg', name: 'ic20-micro-mute', color: '--sui-white', width: '20px', height: '20px'} ,
                  "icon-only": ""
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : (_openBlock(), _createBlock(_component_usersOverflowMock, {
          key: 2,
          users: _ctx.userMedia,
          index: _ctx.getOverflowCheckpoint(),
          onClick: _ctx.clickOverflow
        }, null, 8, ["users", "index", "onClick"])),
    _createVNode(_component_MediaSlotReactions, {
      endpointId: _ctx.tile.stream.id
    }, null, 8, ["endpointId"])
  ], 2))
})